module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "row filters-style"
  }, [_c('div', {
    staticClass: "col-xs-4"
  }, [_c('pl-input', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "Search Courses"
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.filters.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.course_search),
      callback: function($$v) {
        _vm.course_search = $$v
      },
      expression: "course_search"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "teachers col-xs-3"
  }, [_c('multiselect', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "options": _vm.teachers,
      "multiple": true,
      "close-on-select": false,
      "clear-on-select": false,
      "preserve-search": true,
      "placeholder": "Teachers",
      "label": "name",
      "track-by": "id",
      "limit": 1,
      "preselect-first": true
    },
    on: {
      "input": _vm.filters
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function(ref) {
        var values = ref.values;
        var search = ref.search;
        var isOpen = ref.isOpen;

        return [(_vm.selected_teachers.length && !isOpen) ? _c('span', {
          staticClass: "multiselect__single"
        }, [_vm._v("\n            " + _vm._s(_vm.selected_teachers.length) + " Teachers selected\n          ")]) : _vm._e()]
      }
    }]),
    model: {
      value: (_vm.selected_teachers),
      callback: function($$v) {
        _vm.selected_teachers = $$v
      },
      expression: "selected_teachers"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-2 end-xs"
  }, [_c('button', {
    staticClass: "px-8 py-2 rounded cursor-pointer bg-primary text-white text-sm font-semibold disabled:opacity-50",
    staticStyle: {
      "margin": "2px 0px"
    },
    on: {
      "click": _vm.goToAddCourses
    }
  }, [_vm._v("\n      ADD COURSES\n    ")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-121bc5af!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/features/admin/adminPortal/courses/topBar.vue
// module id = 2087
// module chunks = 61